export default __webpack_public_path__ + "static/media/42t.a8d9255b.jpg";